import Headline from 'components/atoms/typography/headline/headline.component';
import React from 'react';
import {useDrugDetails} from './hooks';
import {TypographySizes} from 'components/atoms/typography/base-text/constants';
import styles from './drug-details.styles';
import Paragraph from 'components/atoms/typography/paragraph/paragraph.component';

export default function DrugDetails() {
  const {drug} = useDrugDetails();
  return (
    <div>
        <div style={{padding: 15}}>
            
      <Headline
        stringProps={{plainText: drug.name}}
        size={TypographySizes['2XL']}
        textStyle={styles.titleText}
      />
        </div>
      {Object.keys(drug)
        .filter((key) => key !== 'name')
        .map((key) => (
          <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: 5}}>
            <Paragraph stringProps={{plainText: key}} />{' '}
            <Paragraph stringProps={{plainText: (drug as {[key: string]: any})[key]}} />
          </div>
        ))}
    </div>
  );
}
